<template>
  <button
    @click="resumeRecordingCLick"
    title="Resume recording"
    v-tippy><font-awesome-icon :icon="faDotCircle" /></button>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faDotCircle } from '@fortawesome/pro-light-svg-icons/faDotCircle'
  import { createNamespacedHelpers } from 'vuex'

  const { mapActions, mapState } = createNamespacedHelpers('conference')

  export default {
    components: {
      FontAwesomeIcon
    },
    data () {
      return {
        faDotCircle,
        swalResumeErrorData: {
          type: 'error',
          text: 'Sorry, recording could not be resumed. Please try again.',
          confirmButtonText: 'OK',
          showCloseButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        }
      }
    },
    computed: mapState([
      'activity',
      'recordingButtonDisabled'
    ]),
    methods: {
      ...mapActions([
        'startRecording',
        'resumeRecording',
        'markRecordingState',
        'markRecordingButtonDisabled'
      ]),
      resumeRecordingCLick () {
        this.markRecordingButtonDisabled(true)
        this.resumeRecording(this.swalResumeErrorData)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// recording-resume-button.vue?3b74b37e